<template>
  <main
    class="container">
    <div class='partner_all'>
        <div class='partner_bnr'>
          <div class="img_box"><img :src='youpPath + partnerImgs[0]' /></div>
          <div class='houbao'><img :src='youpPath + partnerImgs[1]' /></div>
          <div class='partner_abs'>
            <div class='partner_txt'>
              <div class='flex space-between'>
                <div class='p_title t_999'>当前提成(元)</div>
                <div class='t_blue' @click="entoExtractDetail">查看明细</div>
              </div>
              <div class='p_tixian'>
                <div class='t_f23030'>{{partnerInfoData.Amount}}</div>
                <div class='p_btn' hover-class="pbtn-hover-class" @click="handleExtract">兑换余额
                </div>
              </div>
              <div class='tixian_list'>
                <div class='tx_left'>
                  <div class='t_999'>历史累计提成(元)</div>
                  <div class='fs-32'>{{partnerInfoData.AmountTotal}}</div>
                </div>
                <div class='tx_right'>
                  <span class='t_999'>推荐注册人数(人)</span>
                  <div class='flex_just'>
                    <span class='fs-32'>{{partnerInfoData.RegisterNumber}}</span>
                    <span class='t_blue' @click="entoHistoryInvite">查看</span>
                  </div>
                </div>
              </div>
            </div>
            <div class='partner_btn' @click="shareClick">
              <img :src='youpPath + partnerImgs[2]' />
            </div>
            <div class='abs_btm_30'>
              <div class='w_up'>
              <img :src='youpPath + partnerImgs[6]' />
              <div class='t_dad2b5'>向上拉了解搜货合伙人的福利</div>
              </div>
            </div>
          </div>
        </div>
        <div class='par_about' id="par_about">
          <div class='par_txt'>
            <div class='par_title'>
              <img :src='youpPath + partnerImgs[4]' />
              <div class='par_title_txt'>什么是搜货合伙人</div>
            </div>
            <img :src='youpPath + partnerImgs[3]' class='par_about_img' />
            <div class='par_content'>{{whatIsPartner}}</div>
          </div>
          <div class='par_rule'>
            <div class='par_title'>
            <img :src='youpPath + partnerImgs[4]' />
            <div class='par_title_txt'>推荐规则</div>
            </div>
            <div class='rule_content'>
            <img :src='youpPath + partnerImgs[5]' />
            <div class='rule_text'>
              <div class='rule_1'>
              <div class='rule_num'>1</div>
              <div>{{recommRule[0]}}</div>
              </div>
              <div class='rule_2'>
              <div class='rule_num'>2</div>
              <div class='rule_txt'>
                <p>{{recommRule[1]}}</p>
              </div>
              </div>
              <div class='rule_3'>
              <div class='rule_num'>3</div>
              <div class='rule_txt'>
                <p>{{recommRule[2]}}</p>
              </div>
              </div>
            </div>
            </div>
            <div class='rule_p'>{{btmTipText}}</div>
          </div>
        </div>
    </div>
  </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config/index'
import { PartnerInfoGet, PartnerAmountToFinance } from '@/api/partner'
import { Toast, Indicator, MessageBox } from 'mint-ui'
export default {
  data () {
    return {
      isAllowUserInfo: false,
      // actionsheet
      isShowSheet: false,
      actionSheetList: ['', '通过二维码分享'],
      youpPath: IMG_BASE_URL,
      sharePic: '/upaiyun/Sys/20180718/5694911098040020986.png',
      // // 奖励金额
      // rewardAmount: '',
      partnerInfoData: {},
      partnerImgs: [
        '/upaiyun/Sys/20180809/5210432231584410222.png',
        '/upaiyun/Sys/20180809/4698437041601681049.png',
        '/upaiyun/Sys/20180809/4871504378359661250.png',
        '/upaiyun/Sys/20180809/4898780711819049971.png',
        '/upaiyun/Sys/20180809/5227631553711485006.png',
        // '/upaiyun/Sys/20180809/5346322077599110442.png',
        '/upaiyun/Sys/20190325/4877701667869580994.jpg',
        '/upaiyun/Sys/20180809/5731216789221578639.png'
      ],
      container: null,
      startClientY: 0,
      whatIsPartner: '',
      // 推荐规则
      recommRule: [],
      btmTipText: ''
    }
  },
  mounted () {
    this.fetchData()
    // this.container = document.getElementsByClassName('container')[0]
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      PartnerInfoGet().then(res => {
        this.partnerInfoData = res.Data
        if (this.partnerInfoData.PartnerLevel <= 3) {
          // 推荐等级
          this.whatIsPartner = `搜货合伙人是搜货精选和用户共同构建的利益链。成为搜货合伙人，推荐好友注册并完成首单购买，你可获得 ${this.partnerInfoData.LevelAmount} 元提成。搜货获得新用户，你获得提成收入，双方互利共赢。`
          this.recommRule = ['分享搜货给好友', '好友注册并进行首次购买 ', `好友确认收货后你得 ${this.partnerInfoData.LevelAmount} 元提成`]
          this.btmTipText = `推荐好友注册搜货精选，当好友首次下单购买，确认收货后你将获得 ${this.partnerInfoData.LevelAmount} 元现金奖励。`
        } else {
          // 分销1、2级
          this.whatIsPartner = ` 搜货合伙人是搜货精选和用户共同构建的利益链。成为搜货合伙人，推荐好友注册，好友每完成一单购买，你可获得 ${this.partnerInfoData.LevelAmount} 元提成。搜货获得新用户，你获得提成收入，双方互利共赢。`
          this.recommRule = ['推荐好友注册', '好友在搜货每购买一单 ', `确认收货后你得 ${this.partnerInfoData.LevelAmount} 元提成`]
          this.btmTipText = `推荐好友注册搜货精选，好友每购买一单，确认收货后你将获得 ${this.partnerInfoData.LevelAmount} 元现金奖励。`
        }
        Indicator.close()
      })
      // CommissionAmount().then(res => {
      //   Indicator.close()
      //   this.rewardAmount = res.Msg
      // }).catch(res => {
      //   Indicator.close()
      //   Toast(res.ErrMsg)
      // })
    },
    // 我要提成
    handleExtract () {
      let isPartnerOpen = this.partnerInfoData.IsPartnerOpen
      if (isPartnerOpen !== '1') {
        MessageBox({
          title: '提示',
          message: '当前合伙人权限关闭，无法兑换提成，请联系客服处理',
          confirmButtonText: '我知道了'
        })
        return
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      PartnerAmountToFinance().then(res => {
        Toast('提成成功')
        Indicator.close()
        this.fetchData()
      }).catch(err => {
        Toast(err.ErrMsg)
        Indicator.close()
      })
    },
    // 查看明细
    entoExtractDetail () {
      this.$router.push('extractDetail')
    },
    // 查看历史推荐人数
    entoHistoryInvite () {
      this.$router.push('recommendFriend')
    },
    // scrollFun (speed, target) {
    //   let container = this.container
    //   let scrollTop = container.scrollTop
    //   let timer = setInterval(function () {
    //     scrollTop = scrollTop + speed
    //     if (speed < 0 && scrollTop < target) {
    //       container.scrollTop = 0
    //       clearInterval(timer)
    //     } else if (speed > 0 && scrollTop > target) {
    //       container.scrollTop = target
    //       clearInterval(timer)
    //     } else {
    //       container.scrollTop = scrollTop
    //     }
    //   }, 30)
    // },
    // handleTouchEnd (e) {
    //   let documentH = document.documentElement.clientHeight || document.body.clientHeight
    //   let endClientY = e.changedTouches[0].clientY
    //   let startClientY = this.startClientY
    //   if (endClientY - startClientY <= 0 && this.container.scrollTop < documentH) {
    //     if (endClientY - startClientY > -80) {
    //       this.scrollFun(-10, 0)
    //     } else {
    //       this.scrollFun(50, documentH)
    //     }
    //   }
    // },
    // throttle (fn, context, delay, text) {
    //   clearTimeout(fn.timeoutId)
    //   fn.timeoutId = setTimeout(function () {
    //     fn.call(context, text)
    //   }, delay)
    // },
    // touchstart (e) {
    //   this.startClientY = e.changedTouches[0].clientY
    // },
    // touchend (e) {
    //   this.throttle(this.handleTouchEnd, null, 100, e)
    // },
    shareClick () {
      this.$router.push({
        name: 'ShareByImg',
        query: {
          pageType: 14
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .partner_all{
    height: 100%;
  }
  .fs-32{
    font-size: 16px;
  }
  .partner_bnr{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    background:#fcf4d5;
  }
  .partner_bnr .img_box{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }
  .partner_bnr .img_box img{
    width: 100%;
    height: 670px;
  }
  .partner_abs{
    position: relative;
    width:90%;
    margin: 0 auto;
    top:145px;
    z-index: 9
  }
  .partner_txt{
    background: #fff;
    padding: 3% 5% 0 5%;
    height:167px;
    padding-top: 50px;
    font-size: 14px;
  }
  .houbao{
    position: absolute;
    top: 95px;
    width: 173px;
    height:105px;
    z-index: 99;
    left: 101px;
  }
  .houbao img{
      width: 173px;
      height: 100px;
  }
  .p_tixian{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
  }
  .p_tixian .t_f23030{
    font-size: 30px;
  }
  .p_btn{
    border: 1px solid #222;
    height:28px;
    line-height: 28px;
    border-radius: 30px;
    width:90px;
    text-align: center;
  }
  .pbtn-hover-class{
    background: #222;
    color: #fff;
  }
  .t_blue{
    color: #457EE8;
  }
  .flex_just ,.tixian_list{
    display: flex;
    justify-content: space-between;
    height: 50%;
    align-items: center;
  }
  .flex_just>span{
    float: left;
  }
  .flex_just>span:nth-of-type(2){
    float: right;
  }
  .tixian_list{
    border-top: 1px solid #eee;
  }
  .partner_btn{
    margin:40px auto 0;
    width: 220px;
    height: 45px;
    position: relative;
  }
  .partner_btn img{
    width: 220px;
    height: 45px;
  }
  .partner_btn button{
    position: absolute;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    border: none;
    outline: none;
    background: transparent;
  }
  .partner_btn button:after{
    border:none;
  }
  .abs_btm_30{
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .w_up{
    width: 100%;
    text-align: center;
  }
  .w_up img{
    width: 38px;
    height: 32px;
    margin:16px auto 0;
    animation: play linear 1s infinite;
  }
  @keyframes play{
    0% {
        transform: translateY(0px)
    }
    50% {
        transform: translateY(-8px)
    }
    100% {
        transform: translateY(0px)
    }
  }
  .t_dad2b5{
    color: #cba26e;
  }
  .par_about{
    background: #fcf4d5;
    padding: 16px;
    font-size: 14px;
  }
  .par_txt{
    background: #fff;
    border-radius: 10px;
    padding:0px 20px 16px 20px;
    text-align: center;
    margin:20px 0;
  }
  .par_title{
    width: 237px;
    margin:0 auto;
    height: 20px;
    position: relative;
  }
  .par_title img{
    width: 237px;
    height: 44px;
    position: absolute;
    top: -20px;
    left: 0;
  }
  .par_title_txt{
    position: absolute;
    width: 237px;
    text-align: center;
    top:-16px;
    color: #72260b;
    font-size: 17px;
  }
  .par_about_img{
    width: 235px;
    height: 91px;
    margin-top:15px;
    margin-bottom: 10px;
  }
  .par_content{
    text-align: left;
    color: #666;
    line-height: 33px;
  }
  .par_rule{
    padding:0 15px 15px 15px;
    background: #fff;
    margin-top:50px;
    border-radius: 10px;
  }
  .rule_content{
    width: 265px;
    height: 396px;
    margin: 25px auto;
    position: relative;
  }
  .rule_content img{
    width: 265px;
    height: 396px;
  }
  .rule_text{
    width: 100%;
    height: 396px;
    position: absolute;
    top: 0;
    left: 0;
    color: #666;
  }
  .rule_num{
    background: #ffcc89;
    color: #fff;
    width:28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    border-radius: 100%;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  .rule_1{
    text-align: center;
    right: 0;
    top: 10px;
    position: absolute;
  }
  .rule_2{
    text-align: center;
    left: 0;
    top:135px;
    position: absolute;
    max-width: 100px;
  }
  .rule_3{
    text-align: center;
    right: 0;
    top:285px;
    position: absolute;
    max-width: 100px;
  }
  .rule_txt text{
    display: block;
    text-align: center;
  }
  .rule_p{
    margin:15px 0px 0px 0px;
    padding: 10px;
    background: #fdf2e3;
    border-radius:8px;
    border:1px dashed #ffcc89;
    color: #888;
  }
  @media screen and (max-height: 568px){
    .abs_btm_30{
      margin-top: 10px;
    }
    .w_up img{
      width: 35px;
      height: 30px;
      margin: 5px auto 0;
    }
  }
</style>
